import { Injectable } from '@angular/core';
import { ApModalService } from 'webcommon/core-ui';
import { FcFilterSaveAsModalComponent } from './fc-filter-save-as-modal.component';

@Injectable({
  providedIn: 'root'
})
export class FcFilterSaveAsModalService {

  constructor(
    private apModalService: ApModalService,
  ) { }

  openModal(
  ) {
    return this.apModalService.showComponentModal$(
      FcFilterSaveAsModalComponent,
      {
        panelClass: ['emds-modal-medium', 'emds-modal-fixed'],
        disableClose: true,
        initialState: {
        }
      }
    );
  }

}
